//
//  SDKVisibilityType.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Source type enum
export var VisibilityType;
(function (VisibilityType) {
    VisibilityType["visible"] = "Visible";
    VisibilityType["hidden"] = "Hidden";
})(VisibilityType || (VisibilityType = {}));
